<nz-calendar
  class="ui-calendar"
  [nzCustomHeader]="customHeaderTemplate || customHeader"
  [nzMode]="mode"
  [nzValue]="value"
  [nzFullscreen]="fullscreen"
  [nzDateCell]="dateCellTemplate"
  [nzDateFullCell]="dateFullCellTemplate"
  [nzMonthCell]="monthCellTemplate"
  [nzMonthFullCell]="monthFullCellTemplate"
  (nzValueChange)="onValueChange($event)"
  (nzModeChange)="onModeChange($event)"
  (nzPanelChange)="onPanelChange($event)"
  (nzSelectChange)="onSelectChange($event)"
>
</nz-calendar>

<ng-template #customHeader>
  <div class="ui-calendar-header">
    <div class="selected-date">
      <span class="date-value">{{ formattedDate }}</span>
    </div>
  </div>
</ng-template>
